export const StorageKeys = {
  EMAIL: 'email',
  PACKAGE_ID: 'packageId',
  SUBSCRIPTION_ID: 'subscriptionId',
  TOKEN: 'accessToken',
  SUMMARY_PRICES: 'summaryPrices',
  SUMMARY_PAYLOAD: 'summaryPayload',
  PROMO_PLAN_ID: 'promoPlanId',
  PROMO_CODES: 'promoCodes',
  PROMO_CODES_APPLY: 'promoCodesApply',
  PLAN_SETTINGS: 'planSettings',
  COUNTRY_CODE: 'countryCode',
  SUMMARY_CHECKOUT_TEXT: 'summaryCheckoutText',
  SUMMARY_DESCRIPTION: 'summaryDescription',
  LOGIN_URL: 'loginUrl',
  PARTNER_ID: 'partnerId',
  PRODUCT_FAMILIES: 'productFamilies',
  EXISTING_USER: 'existingUser',
  QUERY_PARAMS: 'queryParams',
  MARKETING_INFO: 'marketingInfo:',
  WEBINAR_WIZARD: 'webinarWizard:',
  PACKAGE_DATA: 'packageData',
  SOCIAL_TYPE: 'socialType',
  IS_IN_APP_CONTEXT: 'isInAppContext',
  EMAIL_HASH: 'emailHash',
  AVATAR_WIZARD: 'avatarWizard',
} as const;
